import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { MbmProvider } from '@amzn/react-arb-tools';
import Theme from '@amzn/meridian/theme';
import { AnalyticsProvider } from './common/metrics/AnalyticsContext';
import { router } from './router';
import { queryClient } from './api/queryClient';
import mbmOptions from './i18n/utils/mbmOptions';
import '@amzn/meridian-tokens/base/font/amazon-ember.css';
import '@amzn/meridian-tokens/base/font/bookerly.css';
import './globalStyles.scss';
const container = document.getElementById('root');
const root = createRoot(container);
/**
 * The root Meridian theme is "auto" (follows the OS prefers-color-scheme). This is the
 * control behavior. The dark-theme removal is gated by the WEBLAB_PAINTER_DEPRECATE_DARK_MODE
 * weblab in App.tsx, which pins a nested Meridian <Theme> and the @emotion ThemeProvider to
 * light for the treatment (T1) arm. The arm is only known after appInit, so the root stays
 * "auto" here and the gating happens in App.tsx.
 */
root.render(_jsx(React.StrictMode, { children: _jsx(AnalyticsProvider, { children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(MbmProvider, Object.assign({}, mbmOptions, { children: _jsx(Theme, { mode: "auto", children: _jsx(RouterProvider, { router: router }) }) })) }) }) }));
